import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./Login.css"
// import { useState } from 'react'
import { Url } from '../../constants/ApiUrlConstants';
import Lottie from "lottie-react"
import Warning from "../../assets/lottie/Warning.json"
import { contextData } from "../../context/ContextProvider";
import SideCorner from "../../assets/Images/sideCorner (1).png"
import Logo from "../../assets/Images/image_2023_12_04T13_11_15_816Z.png"
import Loader from '../Common/Loader/Loader';
import { AiOutlineEyeInvisible, AiOutlineEye } from 'react-icons/ai';
import { POST } from '../Common/HttpMethods/HttpMethods';
import FailModal from '../Common/Popups/FailModal';
import LoggedOut from '../Common/Popups/LoggedOut';
import { SecretKey, decryptToken, get, set } from '../Encryption/EncryptDecrypt';

export const getDataFromCokkie = (Name) => {
    var CokkieName = Name + "=";
    var CokkieData = decodeURIComponent(document.cookie);
    var cData = CokkieData?.split(";");
    for (var i = 0; i < cData?.length; i++) {
        var Data = cData[i];
        while (Data?.charAt(0) == ',') {
            Data = Data?.substring(1)
        }
        if (Name == 'userId') {
            if (Data?.indexOf(CokkieName) == 0) {
                return Data?.substring(CokkieName?.length, Data?.length)
            }
        } else {
            if (Data?.indexOf(CokkieName) == 1) {

                var Pasword = Data?.substring(CokkieName?.length, Data?.length);
                let RetunrnVar = Pasword.replaceAll('=', '');
                return RetunrnVar;
            }
        }
    }
    return '';
}


export const openlogoutpop = (setLoggedIn) => {
    setLoggedIn(false)
}

export const handleErrorPopup = (setErrorState) => {
    setErrorState(false);
}


export const handleRememberMe = (rememberMe, data) => {
    if (rememberMe) {
        let today = new Date();
        let expire = new Date();
        expire.setTime(today.getTime() + 3600000 * 24 * 45);

        // Assuming you have a token and hashed userId/password
        const token = data.token; // Example: obtained after user authentication
        const userId = btoa(data.userId); // Base64 encoding (use a stronger method in production)
        const passwordHash = btoa(data.password); // Base64 encoding (use a stronger method in production)

        // Store token and hashed credentials in cookies with Secure and HttpOnly attributes
        document.cookie = `token=${token};path=/rnt-qms/;expires=${expire.toUTCString()};HttpOnly;Secure`;
        document.cookie = `userId=${userId};path=/rnt-qms/;expires=${expire.toUTCString()};Secure`;
        document.cookie = `passwordHash=${passwordHash};path=/rnt-qms/;expires=${expire.toUTCString()};Secure`;

    } else {
        // Clear cookies if rememberMe is not selected
        document.cookie = "token=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;HttpOnly;Secure";
        document.cookie = "userId=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;Secure";
        document.cookie = "passwordHash=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;Secure";
    }

    // Redirect the user to the authenticated section of the app
};

export const TokenParseAPI = async (token, setLoggedIn, navigate, setActive, setLoading) => {
    let body = { token: token };
    try {
        let userData = await POST(Url.getUserData, token, body);
        if (userData.SUCCESS) {
            sessionStorage.setItem("UserIdProxy1", userData?.userId)
            sessionStorage.setItem("EMAIL1", userData?.emailId);
            sessionStorage.setItem("USERNAME1", userData?.fullName);
            sessionStorage.setItem("StaffId1", userData?.staffId);
            sessionStorage.setItem("RBAC_roles1", userData?.rbac);
            sessionStorage.setItem("USER_ROLES1", userData?.role);
            sessionStorage.setItem("gender1", userData?.gender);
            setLoggedIn(true);
            navigate('/main');
            setActive("tab1");
            setLoading(false);
            localStorage.clear();
        } else {
            console.error("User data fetch failed:", userData);
        }
    } catch (error) {
        console.error("Error fetching user data:", error);
    }
};

export const handleSubmit = async (
    e,
    data,
    setErrors,
    setLoading,
    rememberMe,
    handleRememberMe,
    setErrorState,
    setLoggedIn,
    navigate,
    setActive
) => {
    e.preventDefault();

    const userIdError = data.userId.length === 0 ? 'Please enter username' : "";
    const passwordError = data.password.length === 0 ? 'Please enter password' : '';

    setErrors({ userId: userIdError, password: passwordError });

    const encryptedData = {
        userId: set(SecretKey, data?.userId),
        password: set(SecretKey, data?.password),
        corsEncryption: false
    };

    if (!userIdError && !passwordError) {
        setLoading(true);

        try {
            const response = await fetch(Url.login, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': 'YmUyYjAzODItOGIyZi00Njk1LThhOGMtYjhkYzVmZDY0YjI2'
                },
                body: JSON.stringify(encryptedData),
            });

            const res = await response.json();

            handleRememberMe(rememberMe, data);

            if (res.SUCCESS) {
                sessionStorage.setItem("TOKEN", res?.TOKEN);
                TokenParseAPI(res?.TOKEN, setLoggedIn, navigate, setActive, setLoading);
            } else {
                setErrorState(true);
                setLoading(false);
            }
        } catch (err) {
            console.error("Error during login:", err);
            setLoading(false);
        }
    }
};

export const handleShowPassword = (setShowHide, showHide) => {
    const fieldType = "password";
    const textType = "text";
    const passwordField = document.getElementById('password');

    if (!passwordField) {
        console.error('Password field not found');
        return;
    }

    if (passwordField.getAttribute('type') === textType) {
        passwordField.setAttribute('type', fieldType);
        setShowHide(false);
    } else {
        passwordField.setAttribute('type', textType);
        setShowHide(true);
    }
};



const Login = () => {
    const { setActive, setLoading, Loading, Active, LoggedIn, setLoggedIn, autoLogin, setAutoLogin } = useContext(contextData);
    // const [openLogoutModal, setopenLogoutModal] = useState();

    const [showHide, setShowHide] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    // const [autoLogin, setAutoLogin] = useState(false)


    const initialErrors = {
        userId: '',
        password: '',
    };
    const [errors, setErrors] = useState(initialErrors);
    const [errorState, setErrorState] = useState(false)

    const [data, setData] = useState(
        {
            userId: "",
            password: ""
        }
    )

    useEffect(() => {
        setAutoLogin(false)
        const localUserName = localStorage.getItem('corpUname');
        const localPassword = localStorage.getItem('corpPass');

        if (localUserName && localPassword) {
            setAutoLogin(true);
            var encryptedData;
            encryptedData = {
                userId: set(SecretKey, localUserName),
                password: localPassword,
                corsEncryption: true
            }

            fetch(Url.login, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': 'YmUyYjAzODItOGIyZi00Njk1LThhOGMtYjhkYzVmZDY0YjI2'
                },
                body: JSON.stringify(encryptedData),
            })
                .then(response => response.json())
                .then(res => {

                    if (res.SUCCESS) {
                        // sessionStorage.setItem("ROLE", "ADMIN");
                        sessionStorage.setItem("TOKEN", res?.TOKEN);
                        TokenParseAPI(res?.TOKEN, setLoggedIn, navigate, setActive, setLoading);
                    }
                    else {
                        // setLoading(false);   
                    }
                })
                .catch(err => {
                    console.log('err', err);
                    // setLoading(false);
                })
        }
    }, [])

    useEffect(() => {
        GetLoginDetailsFromCokkie()
    }, [])


    const navigate = useNavigate();


    const handleReset = () => {
        setData({
            userId: "",
            password: ""
        })
    }

    //=================================Remember me=====================================================>



    const GetLoginDetailsFromCokkie = () => {
        let cokkieUser = getDataFromCokkie("userId");
        let cokkiePass = getDataFromCokkie("password");
        if (cokkieUser !== "" || cokkiePass !== "") {
            setData(prevState => ({
                ...prevState,
                userId: cokkieUser,
                password: cokkiePass
            }));
        }
    };










    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: value.length > 0 ? '' : `Please enter ${name === 'userId' ? 'username' : 'password'}`,
        }));
    };


    return (
        <>
            {!autoLogin ? <div className="container-login">
                <div className="software-details">
                    <div className="login-heading">
                        <div className="login-title">Quality Management System</div>
                        <p className='login-para'>Welcome to Quality Management System (QMS) application – your gateway to streamlined and secure meeting organization. QMS is designed to enhance compliance with SOC controls, standardize meetings, and centralize coordination. Log in to unlock a world where meetings align seamlessly with compliance standards, ensuring a standardized and secure environment for collaboration.</p>
                    </div>
                </div>


                <form className="login-form" data-testid='login-form' onSubmit={(e) => handleSubmit(
                    e,
                    data,
                    setErrors,
                    setLoading,
                    rememberMe,
                    handleRememberMe,
                    setErrorState,
                    setLoggedIn,
                    navigate,
                    setActive
                )}>
                    <div className="loginLogo">
                        <img src={Logo} alt="logo" loading='lazy' />
                    </div>
                    <div className="login-form-content">

                        <div className='loginDataTab'>
                            <label className='Login-labels' htmlFor="">Username <span className='required'>*</span></label>
                            <input className='login-inputs' data-testid='Username-input' type="text" minLength={6} maxLength={20} name='userId' id='username' placeholder='Enter username' value={data?.userId} defaultValue={data?.userId} onChange={handleChange} pattern='\S+' />
                            {errors.userId && <span className='LoginErrors'>{errors.userId}</span>}
                        </div>
                        <div className='loginDataTab'>
                            <label className='Login-labels' htmlFor="">Password <span className='required'>*</span></label>
                            <div className="passwordBox">
                                <input className='login-inputs' data-testid='password-input' type="password" data-password="password" minLength={4} defaultValue={data?.password} value={data?.password} maxLength={20} name="password" id='password' placeholder='Enter password' onChange={handleChange} pattern='\S+' />


                                <span
                                    className="passwordShowAndHide"
                                    data-testid='passwordShowAndHide'
                                    onClick={() => handleShowPassword(setShowHide, showHide)}
                                >
                                    {showHide ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                                </span>
                            </div>
                            {errors.password && <span className='LoginErrors'>{errors.password}</span>}

                        </div>
                        <div className="remember">
                            <div className="remember_me">
                                <input
                                    data-testid="Remember-me"
                                    type="checkbox"
                                    checked={rememberMe}
                                    className='checkContainer'
                                    onChange={() => setRememberMe(!rememberMe)}
                                />
                                <label className='rem' htmlFor="rememberMe">Remember me</label>
                            </div>
                        </div>
                        <div className="login-btns">
                            <button className='loginResetBtn' data-testid='loginResetBtn' type="reset" onClick={() => handleReset()} >Reset</button>
                            <button className='loginSubmitBtn' type='submit' id="submitBtn" >Login</button>
                        </div>
                    </div>
                </form>
                {errorState == true && <div className="loginErrorPopup loginErrorPopup-hidden">
                    <Lottie animationData={Warning} className='loginErrorAmin' />
                    <p style={{ fontSize: '18px' }}>Please enter valid username and password</p>
                    <button className='loginErrorPopupBtn' onClick={()=>handleErrorPopup(setErrorState)}>ok</button>
                </div>}
                <div className="login-sideCorner">
                    <img src={SideCorner} alt="side corner" loading='lazy' />
                </div>
            </div> : <div><Loader /> </div>}

            <LoggedOut LoggedIn={LoggedIn} setLoggedIn={()=>openlogoutpop(setLoggedIn)} />


        </>
    )
}

export default Login




